import BaseListInput from './BaseListInput'

export default class StringListInput extends BaseListInput {
}
